// Shared source of truth for the "Practices" links (nav mega-menu, footer,
// PracticesSection) so the label/href/description can't drift between them.
export const PRACTICES = [
  {
    to: "/ventureryte",
    label: "VentureRyte",
    desc:
      "Venture Capital 2.0 - technology, capital and strategy combined to help founders build and scale.",
  },
  {
    to: "/growryte",
    label: "GrowRyte",
    desc:
      "Diagnoses where activation, engagement, retention or conversion is leaking value - then fixes it.",
  },
];
